import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, ElementRef, ViewChild, Output, ChangeDetectionStrategy, ViewChildren, HostBinding, HostListener, Directive, NgModule } from '@angular/core';
import { FocusKeyManager, A11yModule } from '@angular/cdk/a11y';
import * as i2$1 from 'se-fe-icon';
import { SeFeIconModule } from 'se-fe-icon';
import * as i1 from 'se-fe-position';
import { SeFePositionModule } from 'se-fe-position';

var Keys;
(function (Keys) {
    Keys["ARROW_UP"] = "ArrowUp";
    Keys["ARROW_DOWN"] = "ArrowDown";
    Keys["ENTER"] = "Enter";
    Keys["SPACE"] = "Space";
    Keys["TAB"] = "Tab";
    Keys["ESC"] = "Escape";
    Keys["HOME"] = "Home";
    Keys["END"] = "End";
})(Keys || (Keys = {}));

class SeFeMenuItemContentComponent {
}
SeFeMenuItemContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuItemContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeMenuItemContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SeFeMenuItemContentComponent, selector: "se-fe-menu-item-content", inputs: { menuItem: ["seFeDataItemOption", "menuItem"] }, ngImport: i0, template: "<span *ngIf=\"menuItem.icon\" class=\"se-fe-menu-item-icon\">\n   <se-fe-icon [seFeDataName]=\"menuItem.icon\" seFeDataSize=\"500\"></se-fe-icon>\n</span>\n<span>\n  <p class=\"se-fe-menu-item__text\">{{ menuItem.text }}</p>\n  <p class=\"se-fe-menu-item__sub-text\">{{ menuItem.subText }}</p>\n</span>\n", styles: [":host{display:flex;flex-direction:row;flex-grow:1;font:var(--se-control-font)}.se-fe-menu-item--has-header{padding:var(--se-content-spacing) var(--se-content-spacing-small) var(--se-content-spacing) 24px}.se-fe-menu-item--has-icon{padding-left:16px}.se-fe-menu-item__text,.se-fe-menu-item__sub-text{margin:0;word-break:break-word}.se-fe-menu-item__sub-text{font:var(--se-small-body-font)}.se-fe-menu-item-icon{margin-right:var(--se-content-spacing-small)}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.SeFeIconComponent, selector: "se-fe-icon", inputs: ["seFeDataAriaLabel", "seFeDataSize", "seFeDataColor", "seFeDataName", "seFeDataMargin"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuItemContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'se-fe-menu-item-content', template: "<span *ngIf=\"menuItem.icon\" class=\"se-fe-menu-item-icon\">\n   <se-fe-icon [seFeDataName]=\"menuItem.icon\" seFeDataSize=\"500\"></se-fe-icon>\n</span>\n<span>\n  <p class=\"se-fe-menu-item__text\">{{ menuItem.text }}</p>\n  <p class=\"se-fe-menu-item__sub-text\">{{ menuItem.subText }}</p>\n</span>\n", styles: [":host{display:flex;flex-direction:row;flex-grow:1;font:var(--se-control-font)}.se-fe-menu-item--has-header{padding:var(--se-content-spacing) var(--se-content-spacing-small) var(--se-content-spacing) 24px}.se-fe-menu-item--has-icon{padding-left:16px}.se-fe-menu-item__text,.se-fe-menu-item__sub-text{margin:0;word-break:break-word}.se-fe-menu-item__sub-text{font:var(--se-small-body-font)}.se-fe-menu-item-icon{margin-right:var(--se-content-spacing-small)}\n"] }]
        }], propDecorators: { menuItem: [{
                type: Input,
                args: ['seFeDataItemOption']
            }] } });

class SeFeMenuItemComponent {
    constructor(el) {
        this.el = el;
        this.action = new EventEmitter();
        //noop
    }
    focus() {
        this.button ? this.button.nativeElement.focus() : this.link.nativeElement.focus();
        this.scrollIntoView();
    }
    get menuItemRole() {
        return this.menuOnly ? 'menuitem' : null;
    }
    getItemClass(menuItem) {
        let outputClass = 'se-fe-theme--interactive';
        if (menuItem.disabled === true)
            outputClass += ' se-fe-menu-item--disabled';
        return outputClass;
    }
    menuAction(item) {
        if (item.disabled)
            return;
        this.action.emit();
        item.action(this.triggerEl);
    }
    scrollIntoView() {
        const opts = {
            behavior: 'smooth',
            block: 'nearest'
        };
        this.el.nativeElement.scrollIntoView(opts);
    }
}
SeFeMenuItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuItemComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeMenuItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SeFeMenuItemComponent, selector: "se-fe-menu-item", inputs: { triggerEl: ["seFeDataTriggerEl", "triggerEl"], item: ["seFeDataItemOption", "item"], menuOnly: ["seFeDataMenuOnly", "menuOnly"] }, outputs: { action: "seFeAction" }, viewQueries: [{ propertyName: "button", first: true, predicate: ["menuItemButton"], descendants: true, read: ElementRef }, { propertyName: "link", first: true, predicate: ["menuItemLink"], descendants: true, read: ElementRef }], ngImport: i0, template: "<button\n  #menuItemButton\n  *ngIf=\"item.action\"\n  class=\"se-fe-menu-item\"\n  [attr.role]=\"menuItemRole\"\n  [ngClass]=\"getItemClass(item)\"\n  [attr.aria-disabled]=\"item.disabled\"\n  (click)=\"menuAction(item)\"\n  [attr.aria-label]=\"item.text\"\n  tabindex=\"-1\">\n  <se-fe-menu-item-content [seFeDataItemOption]=\"item\"></se-fe-menu-item-content>\n</button>\n<a\n  role=\"link\"\n  #menuItemLink\n  *ngIf=\"item.href\"\n  [attr.role]=\"menuItemRole\"\n  class=\"se-fe-menu-item\"\n  [ngClass]=\"getItemClass(item)\"\n  [attr.href]=\"item.disabled ? null : item.href\"\n  [attr.target]=\"item.target\"\n  [attr.aria-disabled]=\"item.disabled\"\n  [attr.aria-label]=\"item.text\"\n  tabindex=\"-1\">\n  <se-fe-menu-item-content [seFeDataItemOption]=\"item\"></se-fe-menu-item-content>\n</a>\n", styles: [":host{display:flex;flex-direction:row;flex-grow:1;font:var(--se-control-font);padding:var(--se-content-spacing-xsmall) 0}.se-fe-menu-item{border:0;border-radius:4px;color:var(--se-text);display:block;padding:var(--se-content-spacing);text-align:left;text-decoration:none;width:100%}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SeFeMenuItemContentComponent, selector: "se-fe-menu-item-content", inputs: ["seFeDataItemOption"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'se-fe-menu-item', template: "<button\n  #menuItemButton\n  *ngIf=\"item.action\"\n  class=\"se-fe-menu-item\"\n  [attr.role]=\"menuItemRole\"\n  [ngClass]=\"getItemClass(item)\"\n  [attr.aria-disabled]=\"item.disabled\"\n  (click)=\"menuAction(item)\"\n  [attr.aria-label]=\"item.text\"\n  tabindex=\"-1\">\n  <se-fe-menu-item-content [seFeDataItemOption]=\"item\"></se-fe-menu-item-content>\n</button>\n<a\n  role=\"link\"\n  #menuItemLink\n  *ngIf=\"item.href\"\n  [attr.role]=\"menuItemRole\"\n  class=\"se-fe-menu-item\"\n  [ngClass]=\"getItemClass(item)\"\n  [attr.href]=\"item.disabled ? null : item.href\"\n  [attr.target]=\"item.target\"\n  [attr.aria-disabled]=\"item.disabled\"\n  [attr.aria-label]=\"item.text\"\n  tabindex=\"-1\">\n  <se-fe-menu-item-content [seFeDataItemOption]=\"item\"></se-fe-menu-item-content>\n</a>\n", styles: [":host{display:flex;flex-direction:row;flex-grow:1;font:var(--se-control-font);padding:var(--se-content-spacing-xsmall) 0}.se-fe-menu-item{border:0;border-radius:4px;color:var(--se-text);display:block;padding:var(--se-content-spacing);text-align:left;text-decoration:none;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { triggerEl: [{
                type: Input,
                args: ['seFeDataTriggerEl']
            }], item: [{
                type: Input,
                args: ['seFeDataItemOption']
            }], menuOnly: [{
                type: Input,
                args: ['seFeDataMenuOnly']
            }], button: [{
                type: ViewChild,
                args: ['menuItemButton', { read: ElementRef, static: false }]
            }], link: [{
                type: ViewChild,
                args: ['menuItemLink', { read: ElementRef, static: false }]
            }], action: [{
                type: Output,
                args: ['seFeAction']
            }] } });

class SeFeMenuComponent {
    constructor(elementRef, seFePositionService, cdr) {
        this.elementRef = elementRef;
        this.seFePositionService = seFePositionService;
        this.cdr = cdr;
        this.position = 'bottom left';
        this.fixedPosition = false;
        this.spacing = 4;
        this.styleObject = {};
        this.themeReset = true;
        this._visible = false;
        this.hide = () => this.visible = false;
        this.show = () => this.visible = true;
        this.closeMenuCard = (event) => {
            const path = event.composedPath();
            const externalEvent = !path.includes(this.element);
            const clickedOutside = externalEvent && event.type === 'click' && !path.includes(this.trigger.instance.element);
            const tabbedAway = externalEvent && event.code === Keys.TAB;
            if (clickedOutside)
                this.focusTriggerEl();
            if (tabbedAway)
                this.closeMenu(false);
        };
        // noop
    }
    get inert() { return this.visible ? null : ''; }
    get visible() {
        return this._visible;
    }
    set visible(val) {
        this._visible = val;
        this.visible ? this.bindEvents('addEventListener') : setTimeout(() => this.bindEvents('removeEventListener'));
        this.updateCardTabIndex();
        if (this.trigger)
            this.trigger.instance.updateExpanded();
        this.cdr.markForCheck();
    }
    get visibleClass() {
        return this.visible;
    }
    get ariaHidden() {
        return !this.visible;
    }
    get element() {
        return this.elementRef.nativeElement;
    }
    get cardAriaLabel() {
        return !this.menuOnly ? this.optionString('cardLabel') : null;
    }
    get menuRole() {
        if (this.menuOnly && !this.menuToolbar)
            return 'menu';
        if (!this.menuOnly)
            return 'article';
        return null;
    }
    get ariaLaballedby() {
        return (!this.cardAriaLabel && this.trigger) ? this.trigger.instance.id : null;
    }
    get menuOnly() {
        return this.empty('header') && this.empty('content') && this.empty('footer');
    }
    get menuToolbar() {
        return !this.empty('toolbar');
    }
    get trigger() {
        return this.seFePositionService.triggers.find(t => t.instance.name === this.name);
    }
    manage(event) {
        if (!this.menuOnly)
            return;
        switch (event.code) {
            case Keys.ESC:
                this.closeMenu();
                break;
            case Keys.ARROW_UP:
                event.preventDefault();
                this.keyManager.setPreviousItemActive();
                break;
            case Keys.ARROW_DOWN:
                event.preventDefault();
                this.keyManager.setNextItemActive();
                break;
            case Keys.HOME:
                event.preventDefault();
                this.keyManager.setFirstItemActive();
                break;
            case Keys.END:
                event.preventDefault();
                this.keyManager.setLastItemActive();
                break;
            default:
                break;
        }
    }
    ngOnInit() {
        this.name = this.options.name;
        this.fixedPosition = !!this.options.fixedPosition;
        this.seFePositionService.addContent(this);
        this.updateCardTabIndex();
        this.setStyleObject();
    }
    ngAfterViewInit() {
        if (this.menuOnly)
            this.keyManager = new FocusKeyManager(this.items).withWrap().withHomeAndEnd();
        if (this.menuToolbar) {
            const [input] = this.toolbarContent.nativeElement.querySelectorAll('input');
            if (input)
                input.setAttribute('autocomplete', 'list');
        }
        this.waitForTrigger();
    }
    ngOnDestroy() {
        ['click', 'keyup'].forEach(evt => document.removeEventListener(evt, this.closeMenuCard, false));
        this.seFePositionService.removeContent(this);
    }
    closeMenu(returnFocus = true) {
        if (this.visible && returnFocus)
            this.focusTriggerEl();
        if (this.trigger)
            this.trigger.toggle();
    }
    empty(content) {
        const ref = this[`${content}Content`];
        return !ref || !ref.nativeElement || !ref.nativeElement.innerHTML;
    }
    setStyleObject() {
        const style = this.styleObject;
        style.maxHeight = this.optionString('maxHeight');
        style.maxWidth = this.optionString('maxWidth');
        style.minWidth = this.optionString('minWidth');
    }
    waitForTrigger() {
        const trigger = this.trigger;
        if (!trigger) {
            setTimeout(() => this.waitForTrigger(), 100);
        }
        else {
            this.triggerEl = trigger.instance.element;
            this.cdr.detectChanges();
        }
    }
    bindEvents(method) {
        ['click', 'keyup'].forEach(e => document[method](e, this.closeMenuCard, false));
    }
    optionString(prop) {
        const deprecated = this[prop];
        const value = deprecated || this.options[prop] || '';
        const string = !value || isNaN(value);
        if (deprecated && !SeFeMenuComponent.warned) {
            SeFeMenuComponent.warned = true;
            console.warn('This app uses SeFeMenu inputs that have been deprecated');
        }
        return string ? value : `${value}px`;
    }
    updateCardTabIndex() {
        if (this.menuOnly && !this.menuToolbar)
            return;
        const selectors = 'a.se-fe-menu-item:not(.se-fe-menu-item), area, input, select, textarea, button:not(.se-fe-menu-item), [tabindex]:not(.se-fe-menu-item), [contentEditable=true]';
        const elements = this.elementRef.nativeElement.querySelectorAll(selectors);
        const tabindex = this.visible ? '0' : '-1';
        elements.forEach(el => el.setAttribute('tabindex', `${tabindex}`));
    }
    focusTriggerEl() {
        this._visible = false;
        if (this.trigger)
            this.trigger.instance.buttonEl.focus();
    }
}
SeFeMenuComponent.warned = false;
SeFeMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuComponent, deps: [{ token: i0.ElementRef }, { token: i1.SeFePositionService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SeFeMenuComponent, selector: "se-fe-menu", inputs: { options: ["seFeDataOptions", "options"], maxHeight: ["seFeDataMaxHeight", "maxHeight"], minWidth: ["seFeDataMinWidth", "minWidth"], cardLabel: ["seFeDataCardLabel", "cardLabel"], visible: "visible" }, host: { listeners: { "keydown": "manage($event)" }, properties: { "attr.inert": "this.inert", "class.se-fe-theme--reset": "this.themeReset", "class.se-fe-menu--visible": "this.visibleClass", "attr.aria-hidden": "this.ariaHidden" } }, viewQueries: [{ propertyName: "toolbarContent", first: true, predicate: ["toolbarContent"], descendants: true, read: ElementRef, static: true }, { propertyName: "cardHeader", first: true, predicate: ["cardHeader"], descendants: true, read: ElementRef, static: true }, { propertyName: "cardContent", first: true, predicate: ["cardContent"], descendants: true, read: ElementRef, static: true }, { propertyName: "footerContent", first: true, predicate: ["footerContent"], descendants: true, read: ElementRef, static: true }, { propertyName: "items", predicate: SeFeMenuItemComponent, descendants: true }], ngImport: i0, template: "<div class=\"se-fe-menu-wrapper\"\n  [attr.aria-label]=\"cardAriaLabel\"\n  [attr.aria-labelledby]=\"ariaLaballedby\"\n  [attr.role]=\"menuRole\"\n  [ngStyle]=\"styleObject\"\n  [ngClass]=\"{'se-fe-menu__scrollbar': !!styleObject.maxHeight}\">\n  <div #toolbarContent class=\"se-fe-menu__card-toolbar\" [hidden]=\"empty('toolbar')\">\n    <ng-content select=\"[seFeMenuToolbar]\"></ng-content>\n  </div>\n  <div #headerContent class=\"se-fe-menu__card-header\" [hidden]=\"empty('card')\">\n    <ng-content select=\"[seFeMenuHeader]\"></ng-content>\n  </div>\n  <div #cardContent class=\"se-fe-menu__card-content\" [hidden]=\"empty('card')\">\n    <ng-content select=\"[seFeMenuContent]\"></ng-content>\n  </div>\n  <div #footerContent class=\"se-fe-menu__card-footer\" [hidden]=\"empty('footer')\">\n    <ng-content select=\"[seFeMenuFooter]\"></ng-content>\n  </div>\n  <div\n    class=\"se-fe-menu-section\"\n    *ngFor=\"let section of options.sections\"\n    [ngClass]=\"{'se-fe-menu__divider': section.divider === true }\">\n    <div *ngIf=\"section.header\" class=\"se-fe-menu-section__header\" [attr.aria-label]=\"section.header\">\n      {{ section.header }}\n    </div>\n    <ng-container *ngIf=\"triggerEl\">\n      <se-fe-menu-item *ngFor=\"let item of section.menuItems\" #menuItem (seFeAction)=\"closeMenu()\" [seFeDataTriggerEl]=\"triggerEl\" [seFeDataItemOption]=\"item\" [seFeDataMenuOnly]=\"menuOnly && !menuToolbar\"></se-fe-menu-item>\n    </ng-container>\n  </div>\n</div>\n", styles: [":host{--se-bg: var(--se-popup-bg);font:var(--se-control-font);background:var(--se-bg);box-shadow:var(--se-popup-shadow);overflow:hidden;width:unset;z-index:-99;opacity:0;position:absolute;display:block;pointer-events:none}:host.se-fe-menu--visible{opacity:1;z-index:var(--se-z-popup);pointer-events:all}.se-fe-menu__divider{border-bottom:1px solid var(--se-divider)}.se-fe-menu-wrapper{max-width:288px;min-width:120px;position:relative;padding:var(--se-content-spacing)}.se-fe-menu__scrollbar{overflow-y:scroll;scrollbar-width:thin;scrollbar-color:var(--se-track) var(--se-bg)}.se-fe-menu__scrollbar::-webkit-scrollbar{display:none}.se-fe-menu__scrollbar::-webkit-scrollbar-thumb{background-color:var(--se-track);border-radius:4px}.se-fe-menu__scrollbar::-webkit-scrollbar-track{background-color:var(--se-bg)}.se-fe-menu__scrollbar::-webkit-scrollbar-corner{background-color:transparent}.se-fe-menu__card-toolbar{background-color:var(--se-bg);margin-bottom:calc(var(--se-content-spacing) * -1);padding-top:16px;position:sticky;top:0;z-index:1;transform:translateY(-12px)}.se-fe-menu__card-content,.se-fe-menu__card-footer{padding:var(--se-container-spacing-small)}.se-fe-menu-section:not(:last-child){border-bottom:1px solid var(--se-divider);padding-bottom:var(--se-content-spacing);margin-bottom:var(--se-content-spacing)}.se-fe-menu-section__header{font:var(--se-small-label-font);padding:var(--se-content-spacing) 0 var(--se-content-spacing-xsmall) var(--se-content-spacing);text-align:left;text-transform:uppercase}@media (max-width: 599px){:host{left:0!important}.se-fe-menu-wrapper{max-height:80vh!important;min-width:100vw!important}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: SeFeMenuItemComponent, selector: "se-fe-menu-item", inputs: ["seFeDataTriggerEl", "seFeDataItemOption", "seFeDataMenuOnly"], outputs: ["seFeAction"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'se-fe-menu', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"se-fe-menu-wrapper\"\n  [attr.aria-label]=\"cardAriaLabel\"\n  [attr.aria-labelledby]=\"ariaLaballedby\"\n  [attr.role]=\"menuRole\"\n  [ngStyle]=\"styleObject\"\n  [ngClass]=\"{'se-fe-menu__scrollbar': !!styleObject.maxHeight}\">\n  <div #toolbarContent class=\"se-fe-menu__card-toolbar\" [hidden]=\"empty('toolbar')\">\n    <ng-content select=\"[seFeMenuToolbar]\"></ng-content>\n  </div>\n  <div #headerContent class=\"se-fe-menu__card-header\" [hidden]=\"empty('card')\">\n    <ng-content select=\"[seFeMenuHeader]\"></ng-content>\n  </div>\n  <div #cardContent class=\"se-fe-menu__card-content\" [hidden]=\"empty('card')\">\n    <ng-content select=\"[seFeMenuContent]\"></ng-content>\n  </div>\n  <div #footerContent class=\"se-fe-menu__card-footer\" [hidden]=\"empty('footer')\">\n    <ng-content select=\"[seFeMenuFooter]\"></ng-content>\n  </div>\n  <div\n    class=\"se-fe-menu-section\"\n    *ngFor=\"let section of options.sections\"\n    [ngClass]=\"{'se-fe-menu__divider': section.divider === true }\">\n    <div *ngIf=\"section.header\" class=\"se-fe-menu-section__header\" [attr.aria-label]=\"section.header\">\n      {{ section.header }}\n    </div>\n    <ng-container *ngIf=\"triggerEl\">\n      <se-fe-menu-item *ngFor=\"let item of section.menuItems\" #menuItem (seFeAction)=\"closeMenu()\" [seFeDataTriggerEl]=\"triggerEl\" [seFeDataItemOption]=\"item\" [seFeDataMenuOnly]=\"menuOnly && !menuToolbar\"></se-fe-menu-item>\n    </ng-container>\n  </div>\n</div>\n", styles: [":host{--se-bg: var(--se-popup-bg);font:var(--se-control-font);background:var(--se-bg);box-shadow:var(--se-popup-shadow);overflow:hidden;width:unset;z-index:-99;opacity:0;position:absolute;display:block;pointer-events:none}:host.se-fe-menu--visible{opacity:1;z-index:var(--se-z-popup);pointer-events:all}.se-fe-menu__divider{border-bottom:1px solid var(--se-divider)}.se-fe-menu-wrapper{max-width:288px;min-width:120px;position:relative;padding:var(--se-content-spacing)}.se-fe-menu__scrollbar{overflow-y:scroll;scrollbar-width:thin;scrollbar-color:var(--se-track) var(--se-bg)}.se-fe-menu__scrollbar::-webkit-scrollbar{display:none}.se-fe-menu__scrollbar::-webkit-scrollbar-thumb{background-color:var(--se-track);border-radius:4px}.se-fe-menu__scrollbar::-webkit-scrollbar-track{background-color:var(--se-bg)}.se-fe-menu__scrollbar::-webkit-scrollbar-corner{background-color:transparent}.se-fe-menu__card-toolbar{background-color:var(--se-bg);margin-bottom:calc(var(--se-content-spacing) * -1);padding-top:16px;position:sticky;top:0;z-index:1;transform:translateY(-12px)}.se-fe-menu__card-content,.se-fe-menu__card-footer{padding:var(--se-container-spacing-small)}.se-fe-menu-section:not(:last-child){border-bottom:1px solid var(--se-divider);padding-bottom:var(--se-content-spacing);margin-bottom:var(--se-content-spacing)}.se-fe-menu-section__header{font:var(--se-small-label-font);padding:var(--se-content-spacing) 0 var(--se-content-spacing-xsmall) var(--se-content-spacing);text-align:left;text-transform:uppercase}@media (max-width: 599px){:host{left:0!important}.se-fe-menu-wrapper{max-height:80vh!important;min-width:100vw!important}}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.SeFePositionService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { options: [{
                type: Input,
                args: ['seFeDataOptions']
            }], maxHeight: [{
                type: Input,
                args: ['seFeDataMaxHeight']
            }], minWidth: [{
                type: Input,
                args: ['seFeDataMinWidth']
            }], cardLabel: [{
                type: Input,
                args: ['seFeDataCardLabel']
            }], toolbarContent: [{
                type: ViewChild,
                args: ['toolbarContent', { read: ElementRef, static: true }]
            }], cardHeader: [{
                type: ViewChild,
                args: ['cardHeader', { read: ElementRef, static: true }]
            }], cardContent: [{
                type: ViewChild,
                args: ['cardContent', { read: ElementRef, static: true }]
            }], footerContent: [{
                type: ViewChild,
                args: ['footerContent', { read: ElementRef, static: true }]
            }], items: [{
                type: ViewChildren,
                args: [SeFeMenuItemComponent]
            }], inert: [{
                type: HostBinding,
                args: ['attr.inert']
            }], visible: [{
                type: Input
            }], themeReset: [{
                type: HostBinding,
                args: ['class.se-fe-theme--reset']
            }], visibleClass: [{
                type: HostBinding,
                args: ['class.se-fe-menu--visible']
            }], ariaHidden: [{
                type: HostBinding,
                args: ['attr.aria-hidden']
            }], manage: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class SeFeMenuTriggerDirective {
    constructor(elementRef, seFePositionService) {
        this.elementRef = elementRef;
        this.seFePositionService = seFePositionService;
        this.id = `se-fe-menu-trigger-${Date.now()}-${SeFeMenuTriggerDirective.counter++}`;
        this.event = 'click';
        //noop
    }
    onKeydown(event) {
        if (this.instance && this.instance.menuOnly && !this.instance.menuToolbar) {
            switch (event.code) {
                case Keys.ENTER:
                case Keys.SPACE:
                case Keys.ARROW_DOWN:
                    event.preventDefault();
                    event.stopPropagation();
                    if (!this.content.visible)
                        this.element.click();
                    this.instance.keyManager.updateActiveItem(0);
                    this.instance.keyManager.activeItem.focus();
                    break;
                case Keys.ARROW_UP:
                    event.preventDefault();
                    event.stopPropagation();
                    if (!this.content.visible)
                        this.element.click();
                    this.instance.keyManager.updateActiveItem(0);
                    this.instance.keyManager.setLastItemActive();
                    this.instance.keyManager.activeItem.focus();
                    break;
                default:
                    break;
            }
        }
        else {
            switch (event.code) {
                case Keys.ENTER:
                case Keys.SPACE:
                    event.preventDefault();
                    event.stopPropagation();
                    this.element.click();
                    break;
                default:
                    break;
            }
        }
    }
    get element() {
        return this.triggerConfig ? this.triggerConfigElement : this.elementRef.nativeElement;
    }
    ngOnInit() {
        this.seFePositionService.addTrigger(this);
    }
    updateExpanded() {
        this.buttonEl.setAttribute('aria-expanded', this.instance?.visible ? 'true' : 'false');
    }
    ngAfterViewInit() {
        this.updateAccessibility();
        this.updateExpanded();
    }
    get instance() {
        return this.seFePositionService.contents.find(c => c.name === this.name);
    }
    ngOnDestroy() {
        this.seFePositionService.removeTrigger(this);
    }
    get buttonEl() {
        return this.nestedButton || this.element;
    }
    get triggerConfig() {
        return this.elementRef.nativeElement.querySelector('[seFeMenuTriggerElement]') ?
            true :
            false;
    }
    get triggerConfigElement() {
        return this.elementRef.nativeElement.querySelector('[seFeMenuTriggerElement]');
    }
    get nestedButton() {
        return this.elementRef.nativeElement.querySelector('button');
    }
    get content() {
        return this.seFePositionService.contents.find(c => c.name === this.name);
    }
    updateAccessibility() {
        if (!this.nestedButton) {
            this.element.setAttribute('tabindex', '0');
            this.element.setAttribute('role', 'button');
        }
        if (this.instance && this.instance.menuOnly && !this.instance.menuToolbar) {
            this.buttonEl.setAttribute('aria-haspopup', 'true');
        }
        this.buttonEl.setAttribute('id', this.id);
    }
}
SeFeMenuTriggerDirective.counter = 1;
SeFeMenuTriggerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuTriggerDirective, deps: [{ token: i0.ElementRef }, { token: i1.SeFePositionService }], target: i0.ɵɵFactoryTarget.Directive });
SeFeMenuTriggerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: SeFeMenuTriggerDirective, selector: "[seFeMenuTrigger]", inputs: { name: ["seFeMenuTrigger", "name"] }, host: { listeners: { "keydown": "onKeydown($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[seFeMenuTrigger]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.SeFePositionService }]; }, propDecorators: { name: [{
                type: Input,
                args: ['seFeMenuTrigger']
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class SeFeMenuModule {
}
SeFeMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuModule, declarations: [SeFeMenuComponent,
        SeFeMenuTriggerDirective,
        SeFeMenuItemComponent,
        SeFeMenuItemContentComponent], imports: [CommonModule,
        SeFeIconModule,
        A11yModule], exports: [SeFeMenuComponent, SeFeMenuTriggerDirective] });
SeFeMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuModule, providers: [SeFePositionModule], imports: [CommonModule,
        SeFeIconModule,
        A11yModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SeFeMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SeFeMenuComponent,
                        SeFeMenuTriggerDirective,
                        SeFeMenuItemComponent,
                        SeFeMenuItemContentComponent
                    ],
                    imports: [
                        CommonModule,
                        SeFeIconModule,
                        A11yModule
                    ],
                    exports: [SeFeMenuComponent, SeFeMenuTriggerDirective],
                    providers: [SeFePositionModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { Keys, SeFeMenuComponent, SeFeMenuItemComponent, SeFeMenuItemContentComponent, SeFeMenuModule, SeFeMenuTriggerDirective };
